"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRAFFIC_TYPE_TOUCH = exports.TRAFFIC_TYPE_HOVER = exports.TRAFFIC_TYPE_CUSTOM = exports.TRAFFIC_TYPE_CLICK = exports.TRAFFIC_EID_TAB_CLICK = exports.TRAFFIC_EID_RESIZE = exports.TRAFFIC_EID_OPEN = exports.TRAFFIC_EID_DRAG = exports.TRAFFIC_EID_DOCK = exports.TRAFFIC_EID_CLOSE = exports.TAB_CONTACT = exports.TAB_BROWSE = exports.POSITION_RIGHT = exports.POSITION_LEFT = exports.MARKET_EN_US = exports.LOCALSTORAGE_KEY_STORE_EXPIRES = exports.LOCALSTORAGE_KEY_STORE = exports.ENVS = void 0;
var ENVS = ['dev', 'test', 'prod'];
exports.ENVS = ENVS;
var LOCALSTORAGE_KEY_STORE = 'help-container-store';
exports.LOCALSTORAGE_KEY_STORE = LOCALSTORAGE_KEY_STORE;
var LOCALSTORAGE_KEY_STORE_EXPIRES = 'help-container-store-expires';
exports.LOCALSTORAGE_KEY_STORE_EXPIRES = LOCALSTORAGE_KEY_STORE_EXPIRES;
var MARKET_EN_US = 'en-US';
exports.MARKET_EN_US = MARKET_EN_US;
var POSITION_LEFT = 'left';
exports.POSITION_LEFT = POSITION_LEFT;
var POSITION_RIGHT = 'right';
exports.POSITION_RIGHT = POSITION_RIGHT;
var TAB_BROWSE = 'browse';
exports.TAB_BROWSE = TAB_BROWSE;
var TAB_CONTACT = 'contact';
exports.TAB_CONTACT = TAB_CONTACT;
var TRAFFIC_EID_CLOSE = 'dc.sidekick.container.general.close';
exports.TRAFFIC_EID_CLOSE = TRAFFIC_EID_CLOSE;
var TRAFFIC_EID_DOCK = 'dc.sidekick.container.general.dock';
exports.TRAFFIC_EID_DOCK = TRAFFIC_EID_DOCK;
var TRAFFIC_EID_DRAG = 'dc.sidekick.container.general.drag';
exports.TRAFFIC_EID_DRAG = TRAFFIC_EID_DRAG;
var TRAFFIC_EID_OPEN = 'dc.sidekick.container.general.open';
exports.TRAFFIC_EID_OPEN = TRAFFIC_EID_OPEN;
var TRAFFIC_EID_RESIZE = 'dc.sidekick.container.general.resize';
exports.TRAFFIC_EID_RESIZE = TRAFFIC_EID_RESIZE;
var TRAFFIC_EID_TAB_CLICK = 'dc.sidekick.container.tab.click';
exports.TRAFFIC_EID_TAB_CLICK = TRAFFIC_EID_TAB_CLICK;
var TRAFFIC_TYPE_CLICK = 'click';
exports.TRAFFIC_TYPE_CLICK = TRAFFIC_TYPE_CLICK;
var TRAFFIC_TYPE_CUSTOM = 'custom';
exports.TRAFFIC_TYPE_CUSTOM = TRAFFIC_TYPE_CUSTOM;
var TRAFFIC_TYPE_HOVER = 'hover';
exports.TRAFFIC_TYPE_HOVER = TRAFFIC_TYPE_HOVER;
var TRAFFIC_TYPE_TOUCH = 'touch';
exports.TRAFFIC_TYPE_TOUCH = TRAFFIC_TYPE_TOUCH;